<template>
    <div fluid class="fill-height pt-3">
        <v-row>
            <v-col cols="12">
                <v-row dense>
                    <v-col cols="2">
                        <!-- users -->
                        <v-autocomplete
							v-model="userId"
							:items="usersWithoutPag"
							:item-text="(item) => `${item.employee?.arabicFirstName}` + ' ' + `${item.employee?.arabicLastName}`"
                            item-value="id"
                            :disabled="loading"
                            :return-object="false"
                            label="Employee"
                            dense
                            hide-details
                            class="rounded-lg input"
                            solo
							:background-color="!$vuetify.theme.dark ? 'grey lighten-5' : ''"
                            ></v-autocomplete
                        >
                    </v-col>
                    <v-col cols="2">
                        <v-text-field 
                            v-model="leaves" 
                            label="Leaves during this period"
                            hint="Leaves are entered in hours." 
                            :disabled="loading" 
                            dense
                            hide-details 
                            class="rounded-lg input" 
                            solo
							:background-color="!$vuetify.theme.dark ? 'grey lighten-5' : ''"></v-text-field>
                    </v-col>
                    <v-col cols="2">
                        <v-text-field 
                            v-model="divider" 
                            label="Days divider"
                            hint="How many work days are in this period? (Default: 26)" 
                            :disabled="loading" 
                            dense  
                            hide-details 
                            class="rounded-lg input" 
                            solo
							:background-color="!$vuetify.theme.dark ? 'grey lighten-5' : ''"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="2">
                        <v-menu v-model="menu1" :close-on-content-click="false" :nudge-right="40"
                            transition="scale-transition" offset-y min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field v-model="fromDate" label="From" :disabled="loading"
                                    prepend-icon="mdi-calendar" readonly v-on="on" dense hide-details class="rounded-lg ">
                                </v-text-field>
                            </template>
                            <v-date-picker @input="menu1 = false" :disabled="loading" v-model="fromDate">
                            </v-date-picker>
                        </v-menu> 
                    </v-col>
                    <v-col cols="2">
                        <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40"
                            transition="scale-transition" offset-y min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field v-model="toDate" label="To" :disabled="loading"
                                    prepend-icon="mdi-calendar" readonly v-on="on" dense hide-details
                                    class="rounded-lg">
                                </v-text-field>
                            </template>
                            <v-date-picker @input="menu2 = false" :disabled="loading" v-model="toDate">
                            </v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-spacer />
                    <v-col>
                        <v-btn 
                            :disabled="!userId || !fromDate || !toDate "
                            color="green-color white--text" 
                            @click="isSearch = true; get()" 
                            class="text-none rounded-lg"
                        > 
                            Generate 
                        </v-btn>
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="12">
                <v-card class="mb-3 rounded-lg">
                    <v-card-text class="px-0">
                        <v-simple-table>
                            <template v-slot:default>
                                <tbody>
                                    <tr>
                                        <th>Employee</th>
                                        <td>
                                            {{ employeeName || 'N/A' }}
                                        </td>

                                        <th>Actual hours</th>
                                        <td>{{ totalHours.toFixed(2) }} hours</td>

                                        <th>Daily work hours</th>
                                        <td>{{ dailyHours.toFixed(2) }} hours</td>

                                        <th>Daily work hours (w/o leaves)</th>
                                        <td>{{ dailyHoursWithoutLeaves.toFixed(2) }} hours</td>
                                    </tr>
                                    <!-- <tr>
                                    </tr> -->
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-card-text>
                </v-card>
                <v-data-table 
					v-if="isSearch"
					:headers="headers" 
					:items="projectsEm" 
					:loading="loading" 
					show-expand 
					single-expand
                    :expanded.sync="expanded" 
					item-key="projectId" 
					class="elevation-1 rounded-lg"
                    :items-per-page="-1"
				>
					<template v-slot:item.projectId="{ item }">
                        {{ projects.find(c => c.id === item.projectId).name }}
                    </template>
                    <template v-slot:item.projectHours="{ item }">
                        {{ (item.projectHours / 60).toFixed(2) }} hours
                        <!-- {{ item.projectTasks }} -->
                    </template>
                    <template v-slot:expanded-item="{ item, headers }">
                        <td :colspan="headers.length">
                            <v-simple-table>
                                <template v-slot:default>
                                    <thead>
                                        <tr>
                                            <th class="text-center">Task</th>
                                            <th class="text-center">Date</th>
                                            <th class="text-center">Duration</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="task in item.projectTasks[0].tasks" :key="task.id">
                                            <td dir="rtl" class="text-center">{{ task.description }}</td>
                                            <td class="text-center">{{ (task.start).toString().split('T')[0] }}</td>
                                            <td class="text-center">{{ (task.durationInMinute / 60).toFixed(2) }} hours</td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </td>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
    </div>
</template>

<script>
// import eventBus from '../../../event-bus'
import { mapState, mapGetters } from 'vuex'
// import store from '../../../store'
// import { nonDeleted } from '../../../helpers'
import moment from 'moment'

export default {
	data: () => ({
		userId: null,
		projectId: null,
		fromDate: null,
		toDate: null,
		leaves: null,
		divider: null,
		loading: false,
		menu1: false,
		menu2: false,

		tasks: [],
		totalHours: 0,
		dailyHours: 0,
		dailyHoursWithoutLeaves: 0,
		employeeName: null,

		expanded: [],

		headers: [
			// { text: 'ID', value: 'projectId', sortable: false },
			{ text: 'Project', value: 'projectId', sortable: false },
			{ text: 'Hours', value: 'projectHours' },
			{ text: '', value: 'data-table-expand' }
		],

		projects: [],
		projectsEm: [],
		isSearch: false
	}),

	methods: {
		moment,
		search () {
		// 	this.loading = true
		// 	this.$store.dispatch('stats/fetchEmployeeProjectStats', {
		// 		project_id: this.projectId,
		// 		user_id: this.userId,
		// 		from_date: this.fromDate,
		// 		to_date: this.toDate,
		// 		leaves: this.leaves,
		// 		divider: this.divider
		// 	}).then(data => {
		// 		this.tasks = data.tasks
		// 		this.employeeName = data.tasks[0].user.name
		// 		this.totalHours = data.total_hours
		// 		this.dailyHours = data.daily_hours
		// 		this.dailyHoursWithoutLeaves = data.daily_hours_without_leaves
		// 		this.loading = false
		// 		this.dialog = false
		// 	})
		},
		// nonDeleted
		get () {
			this.loading = true
			this.$store.dispatch('statsctics/fetchUserSalaryStatics', {
				id: this.userId,
				fromDate: this.fromDate,
				toDate: this.toDate,
				daysDivider: this.divider,
				leavesDuringThisPeriod: this.leaves
			}).then((data) => {
				this.projectsEm = data.projects
				this.tasks = data.projects.projectTasks?.tasks.map(c => ({ ...c, id: Math.random() }))
				this.employeeName = data.employeeName
				this.totalHours = (data.actualHours / 60) 
				this.dailyHours = (data.dailyWorkHours / 60)
				this.dailyHoursWithoutLeaves = (data.dailyWorkHoursWithoutLeaves / 60)
				this.loading = false
				this.dialog = false
			}).finally(() => {
				this.loading = false
			})
		}
	},

	computed: {
		...mapState({
			usersWithoutPag: state => state.users.usersWithoutPag
		})
	},

	mounted () {
		this.loading = true
		Promise.all([
			this.$store.dispatch('users/fetchUsersWithoutPag', { isActiveOnly: true }),
			this.$store.dispatch('projects/fetchProjectBrief').then((data) => {
				this.projects = data
			})
		]).finally(() => {
			this.loading = false
		})
	}
}
</script>
